<script>
import Utils from "@/services/utils.js";
import picto_standard from '@/assets/img/picto/1_Standard_yellow.svg'
import picto_premium from '@/assets/img/picto/2_Premium_yellow.svg'
import picto_enterprise from '@/assets/img/picto/3_Enterprise_yellow.svg'

export default {
  name: "ProfilesIndicator",
  props: {
    perf: {
      type: Object,
      default: null,
    },
    nbDatis: {
      type: Number,
      default: 0,
    },
    datisLicences: {
      type: Object,
      default: null,
    },
  },
  methods: {
    dateFormatShort(date) {
      const day = new Date(date).toLocaleDateString(undefined, { year: 'numeric', month: 'numeric', day: 'numeric' })
      const time = new Date(date).toLocaleTimeString(undefined, { hour: 'numeric', minute: 'numeric' })
      return `${day}, ${time}`
    },
    renderLicence: function (idLicence) {
      switch (idLicence) {
        case "45":
          return '<span class="licence-type-45">' + picto_standard + '</span>&nbsp;' + Utils.t('profile.indicators.licence45');
        case "43":
          return '<span class="licence-type-43">' + picto_premium + '</span>&nbsp;' + Utils.t('profile.indicators.licence43');
        case "35":
          return '<span class="licence-type-35">' + picto_premium + '</span>&nbsp;' + Utils.t('profile.indicators.licence35');
        case "58":
          return '<span class="licence-type-58">' + picto_enterprise + '</span>&nbsp;' + Utils.t('profile.indicators.licence58');
        case "57":
          return '<span class="licence-type-57"><i class="fa fa-upload"></i>' + '</span>&nbsp;' + Utils.t('profile.indicators.licence57');
      }
    },
    getAlertName(alertKey) {
      const alertsNames = {
        "beepiz-sos": window.V.$i18n.t("profile.alerts.sos"),
        "beepiz-aggression": window.V.$i18n.t("profile.alerts.aggression"),
        "beepiz-verticality": window.V.$i18n.t("profile.alerts.verticality"),
        "beepiz-immobility": window.V.$i18n.t("profile.alerts.immo"),
        "beepiz-fall": window.V.$i18n.t("profile.alerts.fall"),
        "beepiz-offline-zone-in": window.V.$i18n.t("profile.alerts.offline_zone"),
      }
      return alertsNames[alertKey]
    },
  },
  computed: {
    totalAlerts() {
      let total = 0
      for (const [key, value] of Object.entries(this.perf.last_days_alerts)) {
        total += value
      }
      return total
    },
    lastDaysAlertFiltered() {
      const lastDaysAlerts = this.perf.last_days_alerts
      const lastDaysAlertsFiltered = {}
      for (const [key, value] of Object.entries(lastDaysAlerts)) {
        if (value > 0) {
          lastDaysAlertsFiltered[key] = value
        }
      }
      return lastDaysAlertsFiltered
    },
  }
}
</script>

<template>
  <div class="ProfilesIndicator">
    <ul>
      <template v-if="perf">
        <li>
          <label>{{ $t("profile.indicators.last_alert") }}</label><br />
          <span v-if="perf.last_alert && perf.last_alert.type">
            <i :class="perf.last_alert.type"></i>
            <span v-if="perf.last_alert.dati" v-text="perf.last_alert.dati.name"></span>
            <span v-text="dateFormatShort(perf.last_alert.date.date)"></span>.<br />
            <span class="text-muted" v-if="perf.last_alert.resolved_by">
              {{ $t("profile.indicators.resolved_by") }}
              <span v-text="perf.last_alert.resolved_by"></span></span>
            <em v-else class="text-danger">{{ $t("profile.indicators.not_resolved") }}</em>
          </span>
          <span v-else class="text-muted">{{ $t("profile.indicators.no_alert") }}</span>
        </li>
        <li>
          <label>
            {{ $t("profile.indicators.last_days_alerts") }}
            <span class="text-mono">({{ totalAlerts }})</span>
          </label><br />
          <span v-if="!!totalAlerts">
            <div v-for="(v, k, i) in lastDaysAlertFiltered" :key="k" class="mr-1">
              <i :class="k" class="fa-lg fa-fw"></i> {{ getAlertName(k) }} : <span class="text-mono ml-1" v-text="v"></span>
            </div>
          </span>
          <span v-else class="text-muted">{{ $t("profile.indicators.no_alert") }}</span>
        </li>
        <li v-if="perf.updated_by && !!perf.updated_at">
          <label>{{ $t("profile.indicators.last_update") }}</label><br />
          <span v-text="perf.updated_by"></span>
          <span v-text="dateFormatShort(perf.updated_at.date)"></span>
        </li>
        <li v-if="perf.created_by && !!perf.created_at">
          <label>{{ $t("profile.indicators.creation") }}</label><br />
          <span v-text="perf.created_by"></span>
          <span v-text="dateFormatShort(perf.created_at.date)"></span>
        </li>
      </template>
      <li v-if="datisLicences">
        <label>
          {{ $t("profile.indicators.licences") }}
          <span class="text-mono">({{ nbDatis }})</span>
        </label><br />
        <div class="d-flex flex-column" style="gap: .25em">
          <div v-for="id in ['45', '43', '35', '58', '57']" :key="id" v-if="datisLicences[id] > 0" >
            <span v-html="renderLicence(id)"></span> :
            <span class="text-mono">{{ datisLicences[id] }}</span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<style lang="scss">
.ProfilesIndicator {
  &>ul {
    border: 1px solid var(--colors-gray-200);
    list-style: none;
    padding: 0;
    background-color: var(--colors-gray-50);
    border-radius: var(--radius-md);
  }

  &>ul>li {
    padding: .5rem 1rem;
    border-bottom: 1px solid var(--colors-gray-200);

    &:last-child {
      border-bottom: none;
    }
  }

  label {
    margin: 0;
    font-weight: 600;
    display: inline;
  }
}
</style>